import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

export const ApplyButton = styled(FlexRow)`
    width: 100%;
    height: 40px;
    border-radius: 0 0 2px 2px;
    background: ${colorsPalettes.blue[400]};
    padding-right: 20px;
    justify-content: end;
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
`;

export const Text = styled.p`
    margin: 0;

    ${setFontVariant("button", colorsPalettes.carbon[0])};
`;
